import * as React from "react";
import { Form } from "react-bootstrap";

interface EnfluxCheckboxProps {
    isChecked: boolean;
    id?: string;
    label?: string;
    onChange?: (next: boolean) => void;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

export class EnfluxCheckbox extends React.Component<EnfluxCheckboxProps> {

    handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        if (this.props.onChange) {
            this.props.onChange(ev.target.checked);
        }
    };

    render() {
        return (
            <Form.Check
                type="checkbox"
                id={this.props.id}
                label={this.props.label}
                checked={this.props.isChecked}
                onChange={this.handleChange}
                disabled={this.props.disabled || false}
                readOnly={this.props.readOnly || false}
                className={this.props.className}
            />
        );
    }
}
